import React from "react";
import {OrbitComponent} from "../../../../../../../../base-components/orbit-component/orbit-component";
import {
    GamePlayPcHeaderBarTopRightStartSectionBox
} from "../../../../boxes/sections/top-section/right/game-play-pc-header-bar-top-right-start-section.box";
import {
    HeaderWelcomeButtonsComponent
} from "../../../../../../../../header/welcome-buttons/header-welcome-buttons.component";
import {GamePlayPcHeaderBarTopRightEndSectionBox} from "../../../../boxes/sections/top-section/right/game-play-pc-header-bar-top-right-end-section.box";
import {GamePlayPcHeaderBarFullScreenButtonComponent} from "../../../full-screen-button/game-play-pc-header-bar-full-screen-button.component";

import {GamePlayPcHeaderBarTopRightSectionBox} from "../../../../boxes/sections/top-section/right/game-play-pc-header-bar-top-right-section.box";
import {observer} from "mobx-react";

import {
    GamePlayPcHeaderBarFreePlayIndicatorComponent
} from "../../../free-play/indicator/game-play-pc-header-bar-free-play-indicator.component";
import {
    IGameContextViewModel
} from "../../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {
    GameHeaderBarCloseGameButtonComponent
} from "../../../../../../common/parts/close-game-button/game-header-bar-close-game-button.component";
import {PipeHorizontalSeparatorBox} from "../../../../../../../../../basic-components/pipe-separator/pipe-horizontal-separator.box";
import {BlankHorizontalSeparatorBox} from "../../../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {
    GamePlayPcHeaderBarAddFundsButtonComponent
} from "../../../free-play/add-funds/game-play-pc-header-bar-add-funds-button.component";


interface GamePlayPcHeaderBarTopRightSectionComponentProps {
    gameContext: IGameContextViewModel;
    renderStartSection?: () => React.ReactElement;
    renderEndSection?: () => React.ReactElement;

}

@observer
export class GamePlayPcHeaderBarTopRightSectionComponent extends OrbitComponent<GamePlayPcHeaderBarTopRightSectionComponentProps> {

    private _renderAddFundsButton() {
        if(this.props.gameContext.supportsAddInGameFunds) {
            return (
                <>
                    <BlankHorizontalSeparatorBox/>
                    <GamePlayPcHeaderBarAddFundsButtonComponent gameContext={this.props.gameContext}/>
                </>
            )
        }
        return null;
    }

    private _renderStartSection = () => {
        if (this.props.renderStartSection) {
            return this.props.renderStartSection();
        }

        return (
            <GamePlayPcHeaderBarTopRightStartSectionBox>
                <GamePlayPcHeaderBarFreePlayIndicatorComponent gameContext={this.props.gameContext}/>
                <BlankHorizontalSeparatorBox/>
                <HeaderWelcomeButtonsComponent gameContext={this.props.gameContext}/>
                {this._renderAddFundsButton()}
            </GamePlayPcHeaderBarTopRightStartSectionBox>
        );
    }

    private _renderEndSection = () => {
        if (this.props.renderEndSection) {
            return this.props.renderEndSection();
        }

        return (
            <GamePlayPcHeaderBarTopRightEndSectionBox>
                <GamePlayPcHeaderBarFullScreenButtonComponent/>
                <PipeHorizontalSeparatorBox/>
                <GameHeaderBarCloseGameButtonComponent/>
            </GamePlayPcHeaderBarTopRightEndSectionBox>
        );
    }

    render() {
        return (
            <GamePlayPcHeaderBarTopRightSectionBox>
                {this._renderStartSection()}
                {this._renderEndSection()}
            </GamePlayPcHeaderBarTopRightSectionBox>
        );
    }
}
